'use client'; // Error boundaries must be Client Components

import { useEffect } from 'react';
import { usePathname } from 'next/navigation';

import { PATH } from '@/shared/constants';
import { LogLevel, logger } from '@/shared/utils';
import { ErrorPage } from '@/features/ErrorPage';

export default function Error({
  error,
}: {
  error: Error & { digest?: string };
}) {
  const pathname = usePathname();
  const isDetailPage = pathname?.includes(PATH.DETAIL);

  useEffect(() => {
    logger(LogLevel.ERROR, error, {
      message: '글로벌 에러 페이지 노출',
      detail: {
        path: pathname,
        isDetailPage,
      },
    });
  }, [error, pathname, isDetailPage]);

  return <ErrorPage errorCode="500" isDetailPage={isDetailPage} />;
}
